module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-chooser"
    }
  }, [(_vm.$route.name === 'TryoutSerialForm') ? _c('v-btn', {
    staticClass: "font-weight-bold dark--text",
    staticStyle: {
      "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.05)",
      "border-radius": "4px"
    },
    attrs: {
      "id": "tryout_group_chooser_serial",
      "block": "",
      "depressed": "",
      "color": "#FAFAFA"
    },
    on: {
      "click": _vm.openGroupModal
    }
  }, [_vm._v("Tambah Serial")]) : _c('v-text-field', {
    attrs: {
      "id": "tryout_group_chooser_group",
      "outlined": "",
      "readonly": "",
      "placeholder": _vm.$route.name !== 'DetailPaketMapel' ?
        'Pilih Prasyarat' :
        'Pilih Tryout',
      "clearable": ""
    },
    on: {
      "click": _vm.openGroupModal
    },
    model: {
      value: (_vm.group),
      callback: function($$v) {
        _vm.group = $$v
      },
      expression: "group"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-text', {
          attrs: {
            "width": "100%"
          }
        }, [_c('app-datatable', {
          attrs: {
            "items": _vm.rows,
            "headers": _vm.headers,
            "has-custom-pagination": true,
            "custom-pagination-per-page": _vm.pagination.perPage,
            "custom-pagination-current-page": _vm.pagination.currentPage,
            "hasAction": false
          },
          on: {
            "dblClicked": function($event) {
              return _vm.onTryoutGroupChoosen($event)
            },
            "changePage": function($event) {
              _vm.pagination = Object.assign({}, _vm.pagination,
                {currentPage: $event})
            }
          }
        })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "text-h2"
        })]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29009ffe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_group/components/TryoutGroupChooser.vue
// module id = 2071
// module chunks = 1